export const VIEW_MODE_INLINE = 'inline';
export const VIEW_MODE_MODAL = 'modal';
export const DEFAULT_VIEW_MODE = VIEW_MODE_INLINE;

export function getViewModeStorageKey(userEmail) {
    const user = (userEmail || 'anonymous').toLowerCase().trim();
    return `bridgeOrders.viewModeDefault.v1.${user}`;
}

export function isInlineViewMode(mode) {
    return mode !== VIEW_MODE_MODAL;
}

export function loadViewModeDefault(userEmail) {
    try {
        const raw = localStorage.getItem(getViewModeStorageKey(userEmail));
        if (raw === VIEW_MODE_INLINE || raw === VIEW_MODE_MODAL) {
            return raw;
        }
    } catch (e) { /* ignore storage errors */ }
    return DEFAULT_VIEW_MODE;
}

export function saveViewModeDefault(userEmail, mode) {
    if (mode !== VIEW_MODE_INLINE && mode !== VIEW_MODE_MODAL) return;
    try {
        localStorage.setItem(getViewModeStorageKey(userEmail), mode);
    } catch (e) { /* ignore storage errors */ }
}

export function loadInlineDropdownModeFromPreference(userEmail) {
    return isInlineViewMode(loadViewModeDefault(userEmail));
}
